export default "__VITE_ASSET__D$gKps0t__"